import { InjectionToken } from '@angular/core';
import { PmaDataConfig } from './pma-data.module';

export const PMA_DATA_CONFIG = new InjectionToken<PmaDataConfig>(
  'pma-data-config',
);
